import redirectToLogin from './chains/redirectToLogin'
import setLogin from './chains/setLogin'
import onSignIn from './chains/onSignIn'
import withInitialize from '../app/factories/withInitialize'
import forgotPassword from './chains/forgotPassword'
import Form from 'cerebral-module-forms/Form'
import onForgotPassword from './chains/onForgotPassword'
import unshowRecoverySnackbar from './chains/unshowRecoverySnackbar'
import restorePassword from './chains/restorePassword'
import onRestorePassword from './chains/onRestorePassword'
import validateRegistrationStep from './chains/validateRegistrationStep'
import finishRegistration from './chains/finishRegistration'
import validateRegistrationBeforeNext from './chains/validateRegistrationBeforeNext'
import copyFieldValueForRegistration from './chains/copyFieldValueForRegistration'
import noRoute from './chains/noRoute'
import setAcceptGDPR from './chains/setAcceptGDPR'
import closeGDPRDialog from './chains/closeGDPRDialog'
import toggleAcceptGDPR from './chains/toggleAcceptGDPR'
import setLoginMethod from './chains/setLoginMethod'
import failedThirdPartyLogin from './chains/failedThirdPartyLogin'

export default () => {
  return module => {
    module.addState({
      acceptedGDPR: false,
      showGDPRDialog: false,
      recovery: {
        snackbar: {
          show: false,
          success: false
        },
        forgot: Form({
          email: {
            value: '',
            isRequired: true,
            validations: ['isEmail'],
            errorMessages: [{ key: 'bus-client.errors.email' }]
          }
        }),
        restore: {
          _id: null,
          restored: false,
          loaded: false,
          form: Form({
            password: {
              value: '',
              type: 'password',
              validations: ['equalsField:"confirmPassword"'],
              dependsOn: 'login.recovery.restore.form.confirmPassword',
              errorMessages: [{ key: 'bus-client.errors.confirmPassword' }],
              client: true,
              isRequired: true
            },
            confirmPassword: {
              value: '',
              type: 'password',
              validations: ['equalsField:"password"'],
              errorMessages: [{ key: 'bus-client.errors.confirmPassword' }],
              dependsOn: 'login.recovery.restore.form.password',
              client: true,
              isRequired: true
            }
          })
        }
      }
    })

    module.addSignals({
      redirectToLogin: withInitialize(redirectToLogin),
      setLogin: withInitialize(setLogin),
      forgotPassword: withInitialize(forgotPassword),
      validateRegistrationStep: withInitialize(validateRegistrationStep),
      restorePassword: withInitialize(restorePassword),
      onSignIn,
      copyFieldValueForRegistration,
      validateRegistrationBeforeNext,
      finishRegistration,
      onForgotPassword,
      unshowRecoverySnackbar,
      onRestorePassword,
      noRoute: withInitialize(noRoute),
      setAcceptGDPR,
      closeGDPRDialog,
      toggleAcceptGDPR,
      setLoginMethod,
      failedThirdPartyLogin: withInitialize(failedThirdPartyLogin)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/index.js